<template>
  <div class="card__wrapper">
    <div class="card">
    <a class="btn__chat_bot" target="_blank" href="https://platforma-life-bot.tg.pulse.is">
      <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
<path d="M11.39 22.78C17.6805 22.78 22.78 17.6805 22.78 11.39C22.78 5.09949 17.6805 0 11.39 0C5.09949 0 0 5.09949 0 11.39C0 17.6805 5.09949 22.78 11.39 22.78Z" fill="#5BA1B4"/>
<path d="M4.15013 11.0501L16.0601 6.12009C16.5001 5.94009 16.9601 6.32009 16.8801 6.78009L15.1102 16.1401C15.0202 16.6301 14.4502 16.8501 14.0502 16.5501L9.98015 13.4701C9.76015 13.3001 9.73015 12.9901 9.92015 12.7801L13.2801 9.17011C13.3501 9.09011 13.2502 8.9801 13.1702 9.0401L8.16014 12.4601C7.98014 12.5801 7.76016 12.6201 7.55016 12.5701L4.21013 11.7801C3.83013 11.7201 3.79013 11.2001 4.15013 11.0501Z" fill="white"/>
</svg>
      <span class="btn__chat_bot-text">{{ this.$vuetify.lang.t("$vuetify.main.footer.supportBotText") }}</span>
    </a>
    <div class="social__links">
          <a
            href="https://www.facebook.com/%D0%9F%D0%BB%D0%B0%D1%82%D1%84%D0%BE%D1%80%D0%BC%D0%B0-110554091618488"
            target="_blank"
          >
            <img
              class="footer__social-item"
              src="../../assets/images/icon_fb.svg"
              alt=""
            />
          </a>
          <a
            href="https://instagram.com/platforma.life?utm_medium=copy_link"
            target="_blank"
          >
            <img
              class="footer__social-item"
              src="../../assets/images/icon_inst.svg"
              alt=""
            />
          </a>
          <a href="https://t.me/+Dqd5L573QkpjMWFi" target="_blank">
            <img
              class="footer__social-item"
              src="../../assets/images/icon_tg.svg"
              alt=""
            />
          </a>
          <a href="https://wa.me/380673077887" target="_blank">
            <img
              class="footer__social-item"
              src="../../assets/images/icon_wa.svg"
              alt=""
            />
          </a>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "helpComponent",
  components: {},
  mounted() {},
};
</script>

<style scoped>
.social__links {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 74px;
}
.card__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
.card {
  width: 100%;
  margin: 20px;
  margin-top: 40px;
  max-width: 500px;
  padding: 90px;
  border: 1px solid #00a4b7;
  border-radius: 20px;
}
.btn__chat_bot {
  font-weight: 400;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 10px;
  padding: 10px;
  border-radius: 10px;
  border: 1px solid #00a4b7;
  font-size: 20px;
  color: #575756;
}

@media (max-width: 568px) {
  .card {
    padding: 40px 20px;
  }
  .social__links {
    max-width: 280px;
    margin: auto;
    margin-top: 26px;
  }
  .social__links img {
    max-width: 40px;
  }
}
</style>
